import { render, staticRenderFns } from "./TransactionDetailSection.vue?vue&type=template&id=3efb9726&scoped=true"
import script from "./TransactionDetailSection.vue?vue&type=script&lang=js"
export * from "./TransactionDetailSection.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetailSection.vue?vue&type=style&index=0&id=3efb9726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb9726",
  null
  
)

export default component.exports